import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import isEmptyObject from '../utility/isEmptyObject'
import convertKelvinToCelsius from '../utility/convertKelvinToCelsius'
import convertDegreesToCardinal from '../utility/convertDegreesToCardinal'
import Tooltip from './Tooltip'

const style = theme => ({
  flex: {
    flex: 1
  },
  icon: {
    paddingRight: '20px'
  }
})

class Weather extends PureComponent {
  render () {
    const { classes, weather } = this.props

    if (
      !weather ||
      isEmptyObject(weather) ||
      !weather.weather ||
      !weather.weather[0]
    ) {
      return null
    }

    const { description, icon } = weather.weather[0]
    const { temp: temperature } = weather.main
    const { deg, speed } = weather.wind
    const Svg = require(`../assets/weather-icons/${icon}.svg`)

    return (
      <Toolbar>
        <IconButton className={classes.icon}>
          <img src={Svg.default} alt={`${description} icon`} />
        </IconButton>
        <Typography className={classes.flex}>{description}</Typography>
        <div className={classes.flex}>
          <Tooltip id='temperature' title='temperature' placement='left'>
            <Typography>{`${convertKelvinToCelsius(temperature)}℃`}</Typography>
          </Tooltip>
        </div>
        {/*
        <Typography className={classes.flex}>{`${humidity}%`}</Typography>
        <Typography className={classes.flex}>{`${pressure /
          10} kpa`}</Typography>
        */}
        <div className={classes.flex}>
          <Tooltip id='wind' title='wind' placement='left'>
            <Typography>{`${(speed * 3.6).toFixed(0)} km/hr ${convertDegreesToCardinal(
              deg
            )}`}</Typography>
          </Tooltip>
        </div>
      </Toolbar>
    )
  }
}

export default withStyles(style)(Weather)



// WEBPACK FOOTER //
// ./src/components/Weather.js